import { NavLink } from '../types';

export const navLinks: NavLink[] = [
  { text: 'Commands', url: '/commands' },
  { text: 'Premium', url: '/premium' },
  { text: 'Features', url: '/features' },
  {
    text: 'Add Me',
    url: 'https://discord.com/oauth2/authorize?client_id=1137052528790491228&permissions=2473905114305&response_type=code&redirect_uri=https%3A%2F%2Fthrivebot.in%2Fwelcome&response_type=code&integration_type=0&scope=bot+applications.commands',
    external: true,
  },
  {
    text: 'Discord Server',
    url: 'https://discord.com/invite/ccwu9NpdaH',
    external: true,
  }
];